export default __webpack_public_path__ + "static/media/ledger.58999662.png";